module.exports = __webpack_public_path__ + "img/js.e000390f.png";